// extracted by mini-css-extract-plugin
export default {"title":"style--title--d8c158"};